(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Buyer', Buyer);

    Buyer.$inject = ['$resource', 'DateUtils'];

    function Buyer ($resource, DateUtils) {
        var resourceUrl =  'api/buyers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
